import { useCallback } from "react";
import { RootState } from "../store";
import * as ProductActions from "../store/Product.reducer";
import { useAppDispatch, useAppSelector } from "./hooks";

export default function useProduct() {
  const dispatch = useAppDispatch();

  const product = useAppSelector((state: RootState) => state.product.product);
  const products = useAppSelector((state: RootState) => state.product.list);
  const fetching = useAppSelector((state: RootState) => state.product.fetching);

  const getProducts = useCallback(() => {
    dispatch(ProductActions.getProducts());
  }, [dispatch]);

  return { product, products, getProducts, fetching };
}
